import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';

export function Divider({
  orientation = 'horizontal',
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & { orientation?: 'horizontal' | 'vertical' }) {
  return (
    <span
      role="separator"
      aria-orientation={orientation}
      className={cn(
        orientation === 'horizontal' ? 'block h-px w-full bg-line' : 'block h-5 w-px bg-line',
        className,
      )}
      {...props}
    />
  );
}
